export const ContentIDConstants = {
  Back: 0,
  Header: 1,
  Tooltip1: 2,
  ResolveRegisteredCompanyName: 3,
  ResolveHowDidYouHearAboutUs: 4,
  ResolveSetPassword1: 5,
  ResolveSetPassword2: 6,
  ResolveBusinessIndustry: 7,
  ResolveCustomerType: 8,
  ResolveStateOfOrg: 9,
  ResolveAddress: 10,
  ResolveCompanyURL: 11,
  ResolveNumberOfEmployees: 12,
  ResolveLendingMethod: 13,
  ResolveInvoiceMethod: 14,
};
